import Store from "@/store"

function findPermission(tipo,view,action){ var i = false; Object.keys(tipo).forEach((key) => { tipo[key].forEach((actionKey) => { if (key == view && actionKey == action){ i = true} }) }); return i }

function checkrole(view,action){

  let rol = Store.state.actual_rol; let coordinador  = Store.state.coordinador; let ingeniero = Store.state.ingeniero; let cliente = Store.state.cliente; let gestor = Store.state.gestor; let colaborador = Store.state.colaborador; var act = false

  switch(rol){

    case 'admin': act = true; break;
    case 'coordinador': act = findPermission(coordinador,view,action); break;
    case 'ingeniero': act = findPermission(ingeniero,view,action); break;
    case 'cliente': act = findPermission(cliente,view,action); break;
    case 'gestor': act = findPermission(gestor,view,action); break;
    case 'colaborador': act = findPermission(colaborador,view,action); break;   
    default: act = false; break;
  }

  return act

}

function check_administrador(){ let admins = Store.state.administradores; return admins.some((user)=> user == Store.state.user.email) }

function checkemail(i){ var e = new RegExp(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/); return e.test(i); }
function ftnumber(i){ if(i != 0 || i!='0'){ return i.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.') }else{ return 0 } }
function ftnumberdec(i){ if(i){return parseInt( i.toFixed(2).replace('.', ',').replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.'))} }
function largotext(t,l){ if(t != null){ if(t.length > parseInt(l)){ var res = t.slice(0,parseInt(l)); return res+'..' }else{ return t} } }
function capitaliz(i){ if(i != null){  return i.charAt(0).toUpperCase() + i.slice(1).toLowerCase()} }
function solotareas(p){ let x = Store.state.tareas; var tar = []; for(let i = 0; i < x.length; i++){ if(x[i].parent == p.id && x[i].type != 'project'){ tar.push(x[i]) }}; return tar }

function solomistareas(){

  let t = Store.state.tareas;
  let a = Store.state.asignados;
  let u = Store.state.user;

  var comp = []; var pend = []; var mis = []

  var res = {'propias':mis,'completadas':comp, 'pendientes':pend}

  for (let i = 0; i < t.length; i++) {
    
    for (let x = 0; x < a.length; x++) {
      if(t[i].id == a[x].tarea_id && a[x].user_id == u.id){   
        if(t[i].progress == 1){comp.push(t[i])}
        if(t[i].progress < 1){pend.push(t[i])}
        mis.push(t[i]) 
      }
    }
    
  }

  return res

}

function fechas(f){try{ var x = f.split("-"); var form = x[2]+'-'+x[1]+'-'+x[0]; return form }catch(error){ return '' } }
function fechatime(i){ try { let x = i.split(" "); var y =x[0].split("-"); var f = y[2]+'-'+y[1]+'-'+y[0]+' '+x[1]; return f }catch(error){ return '' } }
function fechaonly(i){ try { let x = i.split(" "); var y =x[0].split("-"); var f = y[2]+'-'+y[1]+'-'+y[0]; return f }catch(error){ return '' } }
function fecha_iso(i,x){ let d = new Date(i); var temp = ''; if(x=='t'){ temp = d.getDate()+'-'+ (d.getMonth()+1) +'-'+d.getFullYear()}; if(x=='l'){ temp = d.getDate()+'-'+(d.getMonth()+1)+'-'+d.getFullYear()+'  '+d.getHours()+':'+d.getMinutes()+':'+d.getSeconds(); }; return temp}

function mistareascp(p){

    let t = solotareas(p); let a = Store.state.asignados; let u = Store.state.user; var comp = []; var pend = []; var mis = []
    var res = {'propias':mis,'completadas':comp, 'pendientes':pend}

    for (let i = 0; i < t.length; i++) {
      
      for (let x = 0; x < a.length; x++) {
        if(t[i].id == a[x].tarea_id && a[x].user_id == u.id){   
          if(t[i].progress == 1){comp.push(t[i])}
          if(t[i].progress < 1){pend.push(t[i])}
          mis.push(t[i]) 
        }
      }
      
    }

    return res

}

function loadpvertk(i,p){

    let t = solotareas(p); var temp = []

    switch(i.recurso){
    
      case 'Todas': temp = t; break;
      case 'Normal': temp = t.filter((y)=>{ return (y.prioridad == 'Normal')}) ; break;
      case 'Alta': temp = t.filter((y)=>{ return (y.prioridad == 'Alta')}); break;
      case 'Media': temp = t.filter((y)=>{ return (y.prioridad == 'Media')}); break;
      case 'Baja': temp = t.filter((y)=>{ return (y.prioridad == 'Baja')}); break;
      case 'Completadas': temp = t.filter((y)=>{ return (y.progress == 1)}); break;
      case 'Pendientes': temp = t.filter((y)=>{ return (y.progress < 1)}); break;
      case 'Mistareas': temp =  mistareascp(p).propias; break;
      case 'Mistareasc': temp =  mistareascp(p).completadas; break;
      case 'Mistareasp': temp =  mistareascp(p).pendientes; break;
      case 'Ninguna': temp = t; break;
      default: temp = t; break;
    }

    return temp

}

function loadpmistk(i){

  let t = solomistareas().propias; var temp = []

  switch(i.recurso){
  
    case 'Todas': temp = t; break;
    case 'Normal': temp = t.filter((y)=>{ return (y.prioridad == 'Normal')}) ; break;
    case 'Alta': temp = t.filter((y)=>{ return (y.prioridad == 'Alta')}); break;
    case 'Media': temp = t.filter((y)=>{ return (y.prioridad == 'Media')}); break;
    case 'Baja': temp = t.filter((y)=>{ return (y.prioridad == 'Baja')}); break;
    case 'Completadas': temp = t.filter((y)=>{ return (y.progress == 1)}); break;
    case 'Pendientes': temp = t.filter((y)=>{ return (y.progress < 1)}); break;
    case 'Mistareas': temp = solomistareas().propias ; break;
    case 'Mistareasc': temp = solomistareas().completadas ; break;
    case 'Mistareasp': temp = solomistareas().pendientes ; break;
    case 'Ninguna': temp = t; break;
    default: temp = t; break;
  }

  return temp

}

function textodia(i){
  let t = '';
  switch(i){
    case 'Mo': t='Monday';break;
    case 'Tu': t='Twesday';break;
    case 'We': t='wednesday';break;
    case 'Th': t='Thursday';break;
    case 'Fr': t='Friday';break;
    case 'Sa': t='Saturday';break;
    case 'Su': t='Sunday';break;
    default: t = 'undefined'; break;
  }
  return t
}

function textomes(i){
  let t = '';
  switch(i){
    case '01': t='January';break;
    case '02': t='February';break;
    case '03': t='March';break;
    case '04': t='April';break;
    case '05': t='May';break;
    case '06': t='June';break;
    case '07': t='July';break;
    case '08': t='August';break;
    case '09': t='September';break;
    case '10': t='October';break;
    case '11': t='November';break;
    case '12': t='December';break;
    default: t = 'undefined'; break;
  }
  return t
}

function textomeslite(i){
  let t = '';
  switch(i){
    case '01': t='Jan';break;
    case '02': t='Feb';break;
    case '03': t='Mar';break;
    case '04': t='Apr';break;
    case '05': t='May';break;
    case '06': t='Jun';break;
    case '07': t='Jul';break;
    case '08': t='Aug';break;
    case '09': t='Sep';break;
    case '10': t='Oct';break;
    case '11': t='Nov';break;
    case '12': t='Dec';break;
    default: t = 'undefined'; break;
  }
  return t
}

function fechalite(i) {
  try{
    var x = i.split("-");
    /*var format = x[2]+'-'+x[1]+'-'+x[0];*/
    var format = x[2];
    return format
  }catch(error){
    return ''
  } 
}

function roltitulo(i) {
  let t = "";
  switch (i) {
      case "admin": t = "Administrador";break;
      case "coordinador": t = "Coordinador"; break;
      case "cliente": t = "Cliente"; break;
      case "ingeniero": t = "Ingeniero"; break;
      case "gestor": t = "Gestor"; break;
      case "colaborador": t = "Colaborador"; break;
      default: t = "Sin categoría";
  }
  return t
}

function color_milestone(i){
  
  let temp = []

  switch(i.color){
      //grd
    case 1: temp = ['bg-gradient-to-r from-gray-100 to-red-400','text-red-500','text-gray-600']; break;
    case 3: temp = ['bg-gradient-to-r from-gray-100 to-yellow-400','text-yellow-500','text-gray-600']; break;
    case 5: temp = ['bg-gradient-to-r from-gray-100 to-green-400','text-green-500','text-gray-600']; break;
    case 7: temp = ['bg-gradient-to-r from-gray-100 to-blue-400','text-blue-500','text-gray-600']; break;
    case 9: temp = ['bg-gradient-to-r from-gray-100 to-indigo-400','text-indigo-500','text-gray-600']; break;
    case 11: temp = ['bg-gradient-to-r from-gray-100 to-purple-400','text-purple-500','text-gray-600']; break;
    case 13: temp = ['bg-gradient-to-r from-gray-100 to-pink-400','text-pink-500','text-gray-600']; break;
    case 15: temp = ['bg-gradient-to-r from-gray-100 to-gray-400','text-gray-500','text-black']; break;
      //lgrd
    case 2: temp = ['bg-gradient-to-r from-gray-100 to-red-300','text-red-400','text-gray-500']; break;
    case 4: temp = ['bg-gradient-to-r from-gray-100 to-yellow-300','text-yellow-400','text-gray-500']; break;
    case 6: temp = ['bg-gradient-to-r from-gray-100 to-green-300','text-green-400','text-gray-500']; break;
    case 8: temp = ['bg-gradient-to-r from-gray-100 to-blue-300','text-blue-400','text-gray-500']; break;
    case 10: temp = ['bg-gradient-to-r from-gray-100 to-indigo-300','text-indigo-400','text-gray-500']; break;
    case 12: temp = ['bg-gradient-to-r from-gray-100 to-purple-300','text-purple-400','text-gray-500']; break;
    case 14: temp = ['bg-gradient-to-r from-gray-100 to-pink-300','text-pink-400','text-gray-500']; break;
    case 16: temp = ['bg-gradient-to-r from-gray-100 to-gray-300','text-gray-400','text-gray-700']; break;
      //solid
    case 17: temp = ['bg-red-500','text-red-500','text-white']; break;
    case 18: temp = ['bg-yellow-500','text-yellow-500','text-white']; break;
    case 19: temp = ['bg-green-500','text-green-500','text-white']; break;
    case 20: temp = ['bg-blue-500','text-blue-500','text-white']; break;
    case 21: temp = ['bg-indigo-500','text-indigo-500','text-white']; break;
    case 22: temp = ['bg-purple-500','text-purple-500','text-white']; break;
    case 23: temp = ['bg-pink-500','text-pink-500','text-white']; break;
    case 24: temp = ['bg-gray-500','text-gray-500','text-white']; break;
      //lsolid
    case 25: temp = ['bg-red-400','text-red-400','text-gray-700']; break;
    case 26: temp = ['bg-yellow-400','text-yellow-400','text-gray-700']; break;
    case 27: temp = ['bg-green-400','text-green-400','text-gray-700']; break;
    case 28: temp = ['bg-blue-400','text-blue-400','text-gray-700']; break;
    case 29: temp = ['bg-indigo-400','text-indigo-400','text-gray-700']; break;
    case 30: temp = ['bg-purple-400','text-purple-400','text-gray-700']; break;
    case 31: temp = ['bg-pink-400','text-pink-400','text-gray-700']; break;
    case 32: temp = ['bg-gray-400','text-gray-100','text-white']; break;

  }

  return temp
}

export default { checkrole,ftnumber,color_milestone,ftnumberdec,checkemail,largotext,capitaliz,fechatime,loadpvertk,loadpmistk,textodia,textomes,fechas,fechaonly,fechalite,roltitulo,textomeslite,fecha_iso,check_administrador }
